export const ENGLISH_LANGUAGE_CODE = 'en';
